var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._g(
      _vm._b(
        {
          staticClass: "my-input",
          style: _vm._style,
          attrs: {
            disabled: _vm.disabled,
            placeholder: _vm.placeholder,
            max: _vm.max,
            min: _vm.min,
            type: _vm.type,
          },
          on: { blur: _vm.blur },
          model: {
            value: _vm._value,
            callback: function ($$v) {
              _vm._value = $$v
            },
            expression: "_value",
          },
        },
        "el-input",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._t("append", null, { slot: "append" }),
      _vm._t("prefix", null, { slot: "prefix" }),
      _vm._t("suffix", null, { slot: "suffix" }),
      _vm._t("prepend", null, { slot: "prepend" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }